import en from "./en.json";
import ru from "./ru.json";
import es from "./es.json";
import it from "./it.json";
import fr from "./fr.json";
import de from "./de.json";
import ee from "./ea.json";
import pl from "./pl.json";
import cs from "./cs.json";
import lb from "./lb.json";


export const defaultLocale = "en"
export const lang = {
    en,
 //   ru,
    es,
  //  it,
  //  fr,
    de,
   // ee
    pl,
    cs,
    lb
}
export const list = [
    {id: "en", name: "English"},
   // {id: "ru", name: "Русский"},
    {id: "es", name: "Español"},
  //  {id: "it", name: "Italiano"},
   // {id: "fr", name: "Français"},
    {id: "de", name: "Deutsch"},
   // {id: "ee", name: "Eesti"},
    { id: "pl", name: "Polski" },
    { id: "cs", name: "Čeština" },
    {id: "lb", name: "Lëtzebuergesch"}
]